import PropertyColor from './property-color';
import PropertyEnum from './property-enum';
import PropertyString from './property-string';
import PropertyNumber from './property-number';
import PropertyLengthMeasure from './property-lenght-measure';
import PropertyToggle from './property-toggle';
import PropertyCheckbox from './property-checkbox';
import PropertyHidden from './property-hidden';
import PropertyReadOnly from './property-read-only';

export { PropertyColor, PropertyEnum, PropertyString, PropertyNumber, PropertyLengthMeasure, PropertyToggle, PropertyCheckbox, PropertyHidden, PropertyReadOnly };

export default {
  PropertyColor: PropertyColor,
  PropertyEnum: PropertyEnum,
  PropertyString: PropertyString,
  PropertyNumber: PropertyNumber,
  PropertyLengthMeasure: PropertyLengthMeasure,
  PropertyToggle: PropertyToggle,
  PropertyCheckbox: PropertyCheckbox,
  PropertyHidden: PropertyHidden,
  PropertyReadOnly: PropertyReadOnly
};